up.compiler(".up_select_fresk_recontacting", function (element, data) {
  const selector = new Choices(element, {
    choices: data.map((e) => {
      let res = {
        value: e.id,
        label: e.title,
      };
      let freskId = element.dataset.defaultid;
      if (freskId && res.value.toString() === freskId) {
        res["selected"] = true;
      }
      return res;
    }),
    placeholder: true,
    placeholderValue: "Fresque",
    removeItemButton: true,
    classNames: {
      containerOuter: ["choices", "w-full", "!mt-2"],
      containerInner: [
        "choices__inner",
        "!bg-white",
        "!pt-3",
        "!pb-2",
        "!rounded-md",
      ],
      item: ["choices__item", "!text-foreground", "!bg-white", "!border-none"],
      button: [
        "choices__button",
        "!text-foreground",
        "!border-none",
        "!bg-[url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMmI0YTNiIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==)]",
      ],
    },
  });

  return () => {
    selector.destroy();
  };
});
